var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("Headline", { attrs: { level: 2, styling: "page-title" } }, [
        _vm._v("Datenschutzerklärung"),
      ]),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _c(
            "Card",
            { staticClass: "card" },
            [
              _c("Paragraph", [
                _vm._v(
                  " Verantwortlicher für die Erhebung, Verarbeitung und Nutzung Ihrer personenbezogenen Daten im Sinne von Art. 4 Nr. 7 DSGVO ist "
                ),
              ]),
              _c("Paragraph", [
                _vm._v(" Ehrengarde der Stadt Neuwied e. V."),
                _c("br"),
                _vm._v(" Elisabethstraße 38"),
                _c("br"),
                _vm._v(" 56564 Neuwied"),
                _c("br"),
              ]),
              _c("Headline", { attrs: { level: 3, styling: "card-title" } }, [
                _vm._v(
                  " Betroffenenrechte: Rechte auf Auskunft, Berichtigung, Sperre, Löschung und Widerspruch "
                ),
              ]),
              _c("Paragraph", [
                _vm._v(
                  " Sie haben das Recht, auf Antrag unentgeltlich eine Auskunft über die bei uns gespeicherten personenbezogenen Daten anzufordern und/oder eine Berichtigung, Sperrung oder Löschung zu verlangen. Eine Sperrung oder Löschung kann nicht erfolgen, wenn gesetzliche Regelungen dem entgegenstehen. "
                ),
              ]),
              _c("Headline", { attrs: { level: 3, styling: "card-title" } }, [
                _vm._v(" Datenvermeidung und Datensparsamkeit "),
              ]),
              _c("Paragraph", [
                _vm._v(
                  " Wir speichern gemäß den Grundsätzen der Datenvermeidung und Datensparsamkeit personenbezogene Daten nur so lange, wie dies erforderlich ist oder vom Gesetzgeber vorgeschrieben wird. "
                ),
              ]),
              _c("Headline", { attrs: { level: 3, styling: "card-title" } }, [
                _vm._v(" Erfassung allgemeiner Informationen "),
              ]),
              _c("Paragraph", [
                _vm._v(
                  " Informationen zu einem Zugriff auf unseren Internetauftritt werden grundsätzlich nicht automatisiert (in Form von Logfiles) erfasst. Für administrative Zwecke kann eine kurzfristige Erstellung von Logfiles notwendig werden. Die Logfiles werden in diesem Fall anschließend gelöscht. Die Logfiles sind von allgemeiner Natur und erlauben keine Rückschlüsse auf Ihre Person. "
                ),
              ]),
              _c("Paragraph", [
                _vm._v(
                  " Sofern Logfiles erstellt werden, können unter anderem folgende Datenarten erfasst werden: IP-Adresse und Datum. "
                ),
              ]),
              _c("Headline", { attrs: { level: 3, styling: "card-title" } }, [
                _vm._v(" Typekit "),
              ]),
              _c("Paragraph", [
                _vm._v(
                  " Um den Besuch unserer Website attraktiv zu gestalten benutzen wir externe Schriften von Adobe Typekit. Diese werden beim Besuch der Seite von Servern der Adobe Systems Inc., San Jose, Kalifornien, USA abgerufen. Adobe setzt dabei keine Cookies zur Erbringung des Dienstes. Nach unseren Informationen wird jedoch die IP-Adresse des Endgerätes des Nutzers an Adobe übertragen und gespeichert. Weitere Informationen zum Datenschutz bei Adobe Typekit finden Sie in der Datenschutzerklärung von Adobe: "
                ),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://www.adobe.com/de/privacy/policies/adobe-fonts.html",
                    },
                  },
                  [
                    _vm._v(
                      " https://www.adobe.com/privacy/policies/typekit.html "
                    ),
                  ]
                ),
              ]),
              _c("Headline", { attrs: { level: 3, styling: "card-title" } }, [
                _vm._v("OpenStreetMap"),
              ]),
              _c("Paragraph", [
                _vm._v(
                  ' Wir binden auf unserer Internetseite die Landkarten des Dienstes "OpenStreetMap" ein ('
                ),
                _c("a", { attrs: { href: "https://www.openstreetmap.de" } }, [
                  _vm._v("https://www.openstreetmap.de"),
                ]),
                _vm._v(
                  "), die auf Grundlage der Open Data Commons Open Database Lizenz (ODbL) durch die OpenStreetMap Foundation (OSMF) angeboten werden. Die Datenschutzerklärung der OpenStreetMap Foundation finden Sie hier: "
                ),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://wiki.openstreetmap.org/wiki/Privacy_Policy",
                    },
                  },
                  [_vm._v("https://wiki.openstreetmap.org/wiki/Privacy_Policy")]
                ),
                _vm._v(". "),
              ]),
              _c("Paragraph", [
                _vm._v(
                  " Nach unserer Kenntnis werden die Daten der Nutzer durch OpenStreetMap ausschließlich zu Zwecken der Darstellung der Kartenfunktionen und Zwischenspeicherung der gewählten Einstellungen verwendet. Es besteht die Möglichkeit, dass beim Aufruf der Landkarten die IP-Adresse sowie die Standortdaten des Nutzers an OpenStreetMap übermittelt, jedoch nicht ohne Einwilligung des Nutzers erhoben werden. Im Regelfall erfolgt diese Einwilligung im Rahmen der Einstellungen im Mobilgerät des Nutzers. "
                ),
              ]),
              _c("Paragraph", [
                _vm._v(
                  " Die erhobenen Daten können in den USA verarbeitet werden. Weitere Informationen können Sie der Datenschutzerklärung von OpenStreetMap entnehmen: "
                ),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://wiki.openstreetmap.org/wiki/Privacy_Policy",
                    },
                  },
                  [_vm._v("https://wiki.openstreetmap.org/wiki/Privacy_Policy")]
                ),
                _vm._v(". "),
              ]),
              _c("Headline", { attrs: { level: 3, styling: "card-title" } }, [
                _vm._v("Carto"),
              ]),
              _c("Paragraph", [
                _vm._v(
                  " Wir binden auf unsere Website die Kartendaten des Dienstes Canto "
                ),
                _c("a", { attrs: { href: "https://carto.com/" } }, [
                  _vm._v("Carto"),
                ]),
                _vm._v(
                  " ein. Es besteht die Möglichkeit, dass beim Aufruf der Landkarten die IP-Adresse sowie die Standortdaten des Nutzers an Carto übermittelt werden. Die erhobenen Daten können in den USA verabeitet werden. weiter Informationen könne Sie der Datenschutzerklärung von Carto entnehem: "
                ),
                _c("a", { attrs: { href: "https://carto.com/privacy/" } }, [
                  _vm._v("https://carto.com/privacy/"),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }